<script>
  import {
    Collapse,
    NavbarToggler,
    NavbarBrand,
    Nav,
    Navbar,
    NavItem,
    NavLink,
  } from '@sveltestrap/sveltestrap'

  import {
    Link,
    page,
  } from '@inertiajs/svelte'

  import News from "../components/_news.svelte"
  import LinkToChatGPT from "./_link_to_chatgpt.svelte"
  import LinkToIf from "../components/_link_to_if.svelte"

  import {
    configure,
    config,
    root_path,
    blog_path,
  } from '../../javascript/routes'

  import { isSamePageIgnoringLocale } from '../../javascript/utils'

  import { I18n } from "i18n-js"
  import i18n_translations from "../../javascript/locales.json"

  let RailsApp = $page.props.RailsApp

  const i18n = new I18n(i18n_translations)
  i18n.locale = RailsApp.I18n.locale

  configure({
    default_url_options: {locale: i18n.locale},
  })
</script>

<header class="mb-4 pt-3 pb-3">
  <div class="container d-flex flex-column flex-sm-row justify-content-between" id="nav">
    <NavbarBrand aria-label="{i18n.t('logo_aria_label')}" href="{root_path()}" class="d-flex align-items-center">
      <img alt="{i18n.t('logo_image_aria_label')}" title="{i18n.t('logo')}" src="{RailsApp.Assets.logo.one_x}" class="d-inline-block align-text-middle" srcset="{RailsApp.Assets.logo.one_x} 1x, {RailsApp.Assets.logo.two_x} 2x" />
      <h1 class="text-black m-0 ms-2 d-inline-block fw-bold">{i18n.t('logo')}</h1>
    </NavbarBrand>
    <ol class="list-unstyled m-0 mt-3 mt-sm-0 p-0 d-flex gap-4">
      <li class="align-self-center">
        <LinkToIf aria-label="{i18n.t('Translations.title')}" condition={!isSamePageIgnoringLocale($page.url, root_path({locale: i18n.locale}))} href="{root_path({locale: i18n.locale})}">
          {i18n.t('Translations.title')}
        </LinkToIf>
      </li>
      <li class="align-self-center">
        <LinkToChatGPT />
      </li>
      <li class="align-self-center">
        <LinkToIf aria-label="{i18n.t('Blog.title')}" condition={!isSamePageIgnoringLocale($page.url, blog_path({locale: i18n.locale}))} href="{blog_path({locale: i18n.locale})}">
          {i18n.t('Blog.title')}
        </LinkToIf>
      </li>
    </ol>
  </div>
</header>
